import stateGo from 'redux-ui-router/lib/state-go';
import {
  isUrlSelected,
  deepFind,
  deepDelete,
  deepMerge,
} from '../../../../util/util';
import selectAction from './selectAction';

export default function toggleSingleSelectEvent(
  { dispatch, getRows, tree },
  { key, parentSlug },
  evt
) {
  const { checked } = evt.target;
  // Use get rows to get the current rows in the slug, and build the new tree
  const active = getRows() || {};
  const parentKeys = parentSlug.length ? parentSlug.split('--') : [];
  const keys = [...parentKeys, key];

  // Perform select action
  dispatch(stateGo('datacenter.main', {
    selectedRows: selectAction(
      active,
      keys,
      checked
    ),
  }));

  // This is a select all off
  if (!isUrlSelected(keys, active)) {
    const event = new CustomEvent('selectAllOff', {
      detail: {
        keys: parentKeys,
      },
    });
    document.dispatchEvent(event);

    // Go though the tree, fine the parent of the unselected item and select
    // all it's children, EXCEPT for the item

    // Parent locator is all but last key
    // Ignore item === last key
    const urlParent = deepFind(parentKeys, active);
    if (urlParent && urlParent.all) {
      deepDelete(parentKeys, active);
      const selectedSiblings =
        Object.keys(
          parentKeys.reduce(
            (acc, curr) =>
              acc[curr] ? acc[curr].children : tree[curr].children,
          {})
        )
        .filter((x) => x !== key)
        .reduce((acc, x) => Object.assign(acc, { [x]: {} }), {});

      // Build a new tree object with the necessary siblings of what
      // was de-selected.
      let newSelection;
      let tempObj = newSelection = {};
      parentKeys.forEach((parentKey, idx) => {
        if (!parentKeys[idx + 1]) {
          if (Object.keys(selectedSiblings).length === 0) {
            return;
          }
          tempObj[parentKey] = selectedSiblings;
        } else {
          tempObj = tempObj[parentKey] = {};
        }
      });

      // Update the tree by performing a deep merge on what exists
      // in the tree, with the new selection.
      dispatch(stateGo('datacenter.main', {
        selectedRows: deepMerge(active, newSelection),
      }));
    }
  }

  return;
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/directives/refineColumns/children/events/toggleSingleSelectEvent.js
 **/